"use client";

import React, { useEffect, useState, useRef } from "react";
import { cn } from "@/utils/cn";
import { manrope } from "@/ui/fonts";
import { Rate } from "antd";

const items = [
  {
    testimonio: {
      comentario: 
        'Llevo dos años utilizando mi scooter Minca y ha sido un cambio completo en mi vida en términos de ahorro de tiempo y estrés por los trancones de la ciudad. Amigable con el medio ambiente y un ahorro increíble para el bolsillo. La mejor opción sin duda para movilizarse en la ciudad!..',
      nombreDeCliente: 'Sebastian Castillo Melguizo',
      rate: 5
    },
    testimonioId: 1061
  },
  {
    testimonio: {
      comentario: 
        'El servicio técnico de mina es uno de los mejores que he tenido! Son muy amables, dan muchas recomendaciones de cómo usar la patineta apropiadamente y ayudan con todo lo que se necesite. Por eso lo recomiendo mucho :)',
      nombreDeCliente: 'Andres Eduardo García Cárdenas',
      rate: 5
    },
    testimonioId: 1060
  },
  {
    testimonio: {
      comentario: 
        'La mejor opción para movilidad dentro de Bogotá. De lejos MINCA ofrece todo lo que se necesita y más. Desde el servicio pre y post venta hasta sus talleres. Recomendado 100%...',
      nombreDeCliente: 'juan diego Bernal',
      rate: 5
    },
    testimonioId: 1059
  },
  {
    testimonio: {
      comentario: 
        'Excelente lugar, me sentí como en casa, me atendió Karin quien fue súper amable y resolvió todas mis inquietudes. Salí feliz con mi producto nuevo! Súper recomendados !! Gracias !!',
      nombreDeCliente: 'Silvana Delgado',
      rate: 5
    },
    testimonioId: 1058
  },
  {
    testimonio: {
      comentario: 
        'Ser parte de la comunidad Minca es lo mejor que me ha pasado ..\r\n' +
        'ahorró tiempo, dinero y disfruto de mis viajes , definitivamente cálidad de vida  !!! Excelente en movilidad ... la mejor inversión...',
      nombreDeCliente: 'Andrea Carolina Ascencio',
      rate: 5
    },
    testimonioId: 1057
  },
  {
    testimonio: {
      comentario: 
        'Excelente servicio. Los técnicos son todos super amables y hacen todo lo posible por ayudarte tan pronto llegas. Tienen varios métodos de pago, ese día se me olvido llevar la billetera y pude pagar por transferencia. En general muy buena experiencia y muy buena marca. 100% recomendado...',
      nombreDeCliente: 'Cata Cortes',
      rate: 5
    },
    testimonioId: 1056
  },
  {
    testimonio: {
      comentario: 'En serio son los más PRO en servicio, atención y tiempos.',
      nombreDeCliente: 'Jeffrey Lopez',
      rate: 5
    },
    testimonioId: 1055
  },
  {
    testimonio: {
      comentario: 
        'Muy satisfecho con mi nueva Scooter Minca 500W. Excelente calidad, precio y diseño. Tiene muy buena respuesta a las necesidades de velocidad que yo buscaba en una pati, buena duración de la carga y cargado realmente rápido. Excelente producto...',
      nombreDeCliente: 'Juan Pablo Villegas G',
      rate: 5
    },
    testimonioId: 1054
  },
  {
    testimonio: {
      comentario: 
        'Un lugar agradable, puedes hacer tu Test Drive de las opciones de scooters, personalizarlas y tomar la mejor opción para comprar! Recomendado!!',
      nombreDeCliente: 'Jefferson Ortiz',
      rate: 5
    },
    testimonioId: 1053
  },
  {
    testimonio: {
      comentario: 
        'Hola Minca, quiero contarte que he tenido una buena experiencia al visitar el lugar la atención y solución fue rápida y agradable, además de eso el seguimiento que realizan luego de salir del lugar para saber el estado de la pantineta.... Genial 👍',
      nombreDeCliente: 'Diana Cañon',
      rate: 5
    },
    testimonioId: 1052
  },
  {
    testimonio: {
      comentario: 
        'Servicio rápido y efectivo, impermeabilización. Atención ágil y expectativas claras😃',
      nombreDeCliente: 'Yair Calderon',
      rate: 5
    },
    testimonioId: 1051
  },
  {
    testimonio: {
      comentario: 
        'El servicio en venta y post venta es bueno, tuve un pequeño problema con mi patineta y lo resolvieron muy rápido, los mantenimientos son de buena calidad, el proceso para ingresar la patineta es inclusive mejor que en marcas de otro tipo de vehículos...',
      nombreDeCliente: 'Ricardo Noguera',
      rate: 5
    },
    testimonioId: 1050
  },
  {
    testimonio: {
      comentario: 
        'He tomado dos decisiones buenas de movilidad, 1 comprarme una patineta electrica y 2 que sea MINCA. Desde que fui a realizar el test drive la atención ha Sido impecable, soy usuario de la 800w modelo nuevo y no tengo más que elogios, excelente calidad, presencia, muy bonitas estéticamente, alta, robusta, rápida, segura. Recomendados 100%...',
      nombreDeCliente: 'Harold Castro',
      rate: 5
    },
    testimonioId: 1049
  },
  {
    testimonio: {
      comentario: 
        'Estoy super feliz con Minca. 1 mes y la asesoría, servicio técnico y profesionalismo me hacen confirmar que tomé la mejor opción...',
      nombreDeCliente: 'Oscar Raúl Camargo Samacá',
      rate: 5
    },
    testimonioId: 1048
  },
  {
    testimonio: {
      comentario: 
        'La marca es increíble, feliz con mi patineta. Definitivamente la mejor inversión que he hecho. La atención en la tienda de cedritos y en el taller del chicó es exelente. En cedritos me atendió Anyelica y siempre ha estado super pendiente de mi experiencia con la marca desde que me vendió la patineta y en el chicó la atención de Karin es súper buena y los chicos del taller súper amables y eficiente',
      nombreDeCliente: 'Sebastian Cardona Orozco',
      rate: 5
    },
    testimonioId: 1047
  },
  {
    testimonio: {
      comentario: 
        'Excelente servicio de la persona que atiende la sucursal de la Javerians, me sentí muy bien orientado y asesorado. Me permitió realizar la test de la patineta y eso me ayudó mucho a tomar la decisión.\r\n' +
        '\r\n' +
        'Quedo contento con la adquisición...',
      nombreDeCliente: 'Jeisson Mejía Roa',
      rate: 5
    },
    testimonioId: 1046
  },
  {
    testimonio: {
      comentario: 
        'Excelente servicio técnico. Lleve mi patineta al taller de la Javeriana y me la entregaron de un día para otro. Gran atención, recomendado.',
      nombreDeCliente: 'Juan Pablo Parada Correa',
      rate: 5
    },
    testimonioId: 1045
  },
  {
    testimonio: {
      comentario: 
        'Cuando iba a comprar mi patineta, revisé muchas y validé el servicio. Algunos conocidos solo pensaban en precio, potencia del patín y en el peso, yo quise mirar algo más, el servicio y creo que no me equivoqué. Me gusta mi patineta Minca y me gusta el servicio de Minca...',
      nombreDeCliente: 'ALEXANDER SUAREZ Q',
      rate: 5
    },
    testimonioId: 1044
  },
  {
    testimonio: {
      comentario: 
        'Mi experiencia en Minca Electric Taller Chicó ha sido excepcional. El servicio al cliente es impecable, con un personal amable y conocedor que realmente se preocupa por sus clientes. He llevado mi patineta aquí en varias ocasiones, y cada vez han superado mis expectativas.\r\n' +
        '\r\n' +
        'Lo que más me impresiona es la calidad del trabajo y la rapidez con la que completan las reparaciones...',
      nombreDeCliente: 'Alejandro Diaz Morales',
      rate: 5
    },
    testimonioId: 1043
  }
]

export const InfiniteMovingCardsTestimonios = ({
  direction = "left",
  speed = "normal",
  pauseOnHover = true,
  className,
}) => {
  const containerRef = useRef(null);
  const scrollerRef = useRef(null);
  const [start, setStart] = useState(false);
  useEffect(() => {
    addAnimation();
  }, []);

  const addAnimation = () => {
    if (containerRef.current && scrollerRef.current) {
      const scrollerContent = Array.from(scrollerRef.current.children);

      scrollerContent.forEach((item) => {
        const duplicatedItem = item.cloneNode(true);
        scrollerRef.current.appendChild(duplicatedItem);
      });

      getDirection();
      getSpeed();
      setStart(true);
    }
  };

  const getDirection = () => {
    if (containerRef.current) {
      if (direction === "left") {
        containerRef.current.style.setProperty(
          "--animation-direction",
          "forwards",
        );
      } else {
        containerRef.current.style.setProperty(
          "--animation-direction",
          "reverse",
        );
      }
    }
  };

  const getSpeed = () => {
    if (containerRef.current) {
      if (speed === "fast") {
        containerRef.current.style.setProperty("--animation-duration", "20s");
      } else if (speed === "normal") {
        containerRef.current.style.setProperty("--animation-duration", "40s");
      } else {
        containerRef.current.style.setProperty("--animation-duration", "80s");
      }
    }
  };

  return (
    <div
      ref={containerRef}
      className={cn(
        "scroller relative z-20  w-full overflow-hidden  ",
        className,
      )}
    >
      <ul
        ref={scrollerRef}
        className={cn(
          " flex w-max min-w-full shrink-0 flex-nowrap gap-4 py-4",
          start && "animate-scroll ",
          pauseOnHover && "hover:[animation-play-state:paused]",
        )}
      >
        {items.map((item, idx) => (
          <li
            className="relative w-[350px] max-w-full flex-shrink-0 rounded-2xl border border-b-0  px-8 py-6 md:w-[450px] bg-black"
            
            key={`infinite-moving-card-${idx}`}
          >
            <blockquote>
              <div
                aria-hidden="true"
                className="user-select-none -z-1 pointer-events-none absolute -left-0.5 -top-0.5 h-[calc(100%_+_4px)] w-[calc(100%_+_4px)]"
              ></div>
              <div className="-minca-rate flex items-center justify-between">
                <Rate allowHalf defaultValue={item.testimonio.rate} />
                <img
                  className="h-[25px] w-[25px]"
                  src="/google.png"
                  alt="imagen google"
                />
              </div>
              <div className="relative z-20 mt-6 flex flex-row items-center">
                <span className="flex flex-col gap-1">
                  <span className=" text-sm leading-[1.6] text-gray-400 font-bold">
                    {item.testimonio.nombreDeCliente}
                  </span>
                  <span className=" text-sm font-normal leading-[1.6] text-gray-400">
                    {item.testimonio.comentario}
                  </span>
                </span>
              </div>
            </blockquote>
          </li>
        ))}
      </ul>
    </div>
  );
};
